import styled, { css } from 'styled-components';

import { deviceWidth } from '../../designs/devices';

export const INVToolBar = styled.div<{
  compliance: boolean;
}>`
position:fixed;
width:100%
top:64px;
height: 56px;
display:flex;
flex-direction:row;
align-items:center;
justify-content:space-between;
box-sizing: border-box;
background:#ffff;
z-index:100;
box-shadow: 0px 15px 32px -15px rgba(69, 74, 222, 0.12);
padding:5%;
@media ${deviceWidth.mobileXS} { 
    padding:1%;
}
@media ${deviceWidth.mobileS} { 
    padding:3%;
}

${(props) =>
  props.compliance &&
  css`
    height: 50px;
    top: 75px;
    padding-top: 0%;
  `}
`;

export const INVContainer = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  background-color: #f3f3fd;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 0;
  box-sizing: border-box;
  padding-left: 5%;
  padding-right: 5%;
`;

export const Container = styled.div<{
  compliance: boolean;
}>`
  position: fixed;
  overflow-y: scroll;
  width: 100%;
  top: 120px;
  ${(props) =>
    props.compliance === true &&
    css`
      height: calc(100vh - 176px);
    `}
  ${(props) =>
    props.compliance === false &&
    css`
      height: calc(100vh - 120px);
      z-index: 50;
    `}
`;

export const INVFooter = styled.div<{
  compliance: boolean;
}>`
  position: fixed;
  height: 48px;
  width: 100%;
  background: #ffff;
  box-sizing: border-box;
  ${(props) =>
    props.compliance &&
    css`
      bottom: 0px;
      z-index: 50;
    `}
  ${(props) =>
    props.compliance === false &&
    css`
      bottom: 56px;
      z-index: 100;
    `}
`;

export const FooterBtn = styled.button`
  width: 50%;
  height: 48px;
  background: #ffff;
  outline: none;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #1572ed;
  border: none;
`;

export const FooterLine = styled.div`
  width: 1px;
  height: 40px;
  margin-top: 5px;
  background: #ebebec;
`;
